export default __webpack_public_path__ + "static/media/vocalnet1.8cdf78c5.mp4";